import applyForm from './apply-form'
import calculator from './calculator'
import callbackForm from './callback-form'
import copyLink from './copy-link'
import creditForm from './credit-form'
import dialog from './dialog'
import partnerForm from './partner-form'
import rangeSlider from './range-slider'
import posts from './posts'

export default function (Alpine) {
  Alpine.data('rangeSlider', rangeSlider)
  Alpine.data('copyLink', copyLink)
  Alpine.data('posts', posts)
  Alpine.data('applyForm', applyForm)
  Alpine.data('callbackForm', callbackForm)
  Alpine.data('creditForm', creditForm)
  Alpine.data('dialog', dialog)
  Alpine.data('partnerForm', partnerForm)
  Alpine.data('calculator', calculator)
}
